import _includes from "lodash/includes";
import _assign from "lodash/assign";
import _last from "lodash/last";
import _get from "lodash/get";
//
import BackButton from "../../services/BackButton";
import { createAction } from "redux-actions";
import {
  BOOKING_GENDER_SET,
  BOOKING_PHONE_UPDATE,
  EMAIL_OTP_SEND,
} from "../booking/actions";
import {
  MODEL_SHOW,
  MODEL_PREBOOK,
  MODELS_GET,
  ACCEPT_TIME,
  REJECT_TIME,
  getModelsIfNeededAction,
} from "../models/actions";
import { cancelFiltersAction } from "../filters";
import { AJAX_ERROR } from "../ajax";
import { INTL_REGION_SET, INTL_CITY_SET } from "../intl";
import {
  MODAL_SHOW,
  MODAL_HIDE,
  CAROUSAL_SHOW,
  CAROUSAL_HIDE,
  MODAL_SCREEN_SHOW,
  SCREENS_PUSH,
  SEARCH_EDIT,
  HISTORY_POP,
} from "./actionTypes";
import { _pop, _push } from "../../utils";

// ----------------------------------------------------------------------------------------------------------------------------
//  Actions
// ----------------------------------------------------------------------------------------------------------------------------
export const showModal = createAction(MODAL_SHOW);
export const hideModal = createAction(MODAL_HIDE);
export const showCarousal = createAction(CAROUSAL_SHOW);
export const hideCarousal = createAction(CAROUSAL_HIDE);
export const showScreen = createAction(MODAL_SCREEN_SHOW);
export const pushScreens = createAction(SCREENS_PUSH);
export const popHistory = createAction(HISTORY_POP);
export const doEditSearch = createAction(SEARCH_EDIT);

const NOBACK = [
  "verify",
  // "verify-phone",
  "verify-phone-otp",
  "verify-email-otp",
];

export const editSearch = (screen) => (dispatch, getState) => {
  dispatch(doEditSearch());
  dispatch(showScreen(screen));
};

export const goToBack = () => (dispatch, getState) => {
  const { modal, models } = getState();
  const { history } = modal;

  if (!history.length) {
    return;
  }

  const currentScreen = history[history.length - 1];

  // Prevent to go back on certain screens
  if (_includes(NOBACK, currentScreen)) {
    return;
  }

  // Note: Here, local @var history will not be affected by the Dispatch
  dispatch(popHistory());

  let previousScreen;

  if (history.length > 1) {
    previousScreen = history[history.length - 2];
  } else {
    return dispatch(hideModal());
  }

  switch (currentScreen) {
    case "carousal":
      // /!\ Execution stops here! (return)
      return dispatch(hideCarousal());

    case "filters":
      dispatch(cancelFiltersAction());
      break;

    case "error":
      previousScreen = "models";
      break;

    case "location":
      previousScreen = models.active ? "book" : "outcall";
      break;

    // If go back from steps
    case "duration":
    case "time":
    case "gender":
    case "outcall":
    case "region":
    case "city":
      // /!\ Execution stops here! (return)
      return dispatch(editSearch(previousScreen));

    case "region":
    case "thankyou":
      // /!\ Execution stops here! (return)
      // (Note: history is reset)
      return dispatch(hideModal());

    default:
      break;
  }

  if (previousScreen === "models") {
    dispatch(getModelsIfNeededAction());
  }

  if (previousScreen) {
    dispatch(showScreen(previousScreen));
  } else {
    throw new Error("Wrong history");
  }
};

export const goToScreen = (name) => (dispatch) => {
  dispatch(showScreen(name));
};

// ----------------------------------------------------------------------------------------------------------------------------
//  Reducer
// ----------------------------------------------------------------------------------------------------------------------------
const serverState = window.initialState;

const initialState = _assign(
  {
    history: [],
    initialScreen: "region",
    screen: "",
    isOpen: false,
    carousalIdx: 0,
    modelId: _get(serverState, "models.active"),
  },
  serverState.modal
);

export default function (state = initialState, action) {
  switch (action.type) {
    case MODAL_SHOW:
      return applyShowModal(state, action);

    case MODAL_HIDE:
      return applyHideModal(state, action);

    case CAROUSAL_SHOW:
      return applyShowCarousal(state, action);

    case MODAL_SCREEN_SHOW:
      return _pushScreen(state, action.payload);

    case SCREENS_PUSH:
      return _pushScreens(state, action.payload);

    case INTL_REGION_SET:
      return _pushScreen(state, "city");

    case INTL_CITY_SET:
      return _pushScreen(state, "gender");

    case BOOKING_GENDER_SET:
      return _pushScreen(state, "outcall");

    case MODELS_GET.FULFILLED:
      // case FILTERS_CANCEL:
      return _pushScreen(state, "models");

    case MODEL_SHOW:
    case CAROUSAL_HIDE:
      return _pushScreen(state, "model");

    case MODEL_PREBOOK.FULFILLED:
      return applyShowBook(state, action);

    case BOOKING_PHONE_UPDATE.FULFILLED:
      return _pushScreen(state, "verify-phone-otp");

    case AJAX_ERROR:
      const { error } = action.payload;

      if (isErrorScreen(error)) {
        // Here we ignore history
        return {
          ...state,
          screen: "error",
        };
      }

      return state;

    case EMAIL_OTP_SEND.FULFILLED:
      return _pushScreen(state, "verify-email-otp");

    case HISTORY_POP:
      return {
        ...state,
        history: _pop(state.history),
      };

    case ACCEPT_TIME:
      return _pushScreen(state, "book");

    case REJECT_TIME:
      return _pushScreen(state, "time");

    default:
      return state;
  }
}

// -----------------------------------------------------------------------------
//  Action Reducers
// -----------------------------------------------------------------------------
function applyShowModal(state) {
  // -- Hack: https://github.com/reactjs/react-modal/issues/99
  document.body.classList.add("modal-opened");
  document.body.classList.remove("modal-loading");
  // Hack --

  let newState;

  if (state.screen) {
    // Some screen has already been pushed
    newState = { ...state };
  } else {
    // Push initial screen (default)
    newState = _pushScreen(state, initialState.initialScreen);
  }

  newState.isOpen = true;

  return newState;
}

function applyHideModal(state) {
  // -- Hack: https://github.com/reactjs/react-modal/issues/99
  document.body.classList.remove("modal-opened");
  // Hack --

  return applyReset(state);
}

function applyShowCarousal(state, action) {
  const newState = _pushScreen(state, "carousal");

  newState.carousalIdx = action.payload;

  return newState;
}

function _pushScreen(state, screen) {
  return _pushScreens(state, [screen]);
}

function _pushScreens(oldState, screens) {
  const screen = _last(screens);

  gtag("event", "page_view", {
    page_title: `/app/${screen}`,
  });

  BackButton.setCurrentScreen(screen);

  const state = { ...oldState, screen };
  const currentScreen = state.history[state.history.length - 1];

  if (screen !== currentScreen) {
    if (screens.length === 1) {
      const index = state.history.findIndex((val) => val === screen);

      if (index !== -1) {
        state.history.splice(index);
      }
    }

    state.history.push(...screens);
  }

  return state;
}

function applyReset(state) {
  return { ...initialState };
}

function applyShowBook(state, action) {
  const { modelId, history } = state;

  // Preselect model IF not selected:
  // Is model landing page AND history < Results page
  const preselect = modelId === action.payload && history.length < 6;
  const screens = ["book"];

  if (preselect) {
    screens.unshift("models", "model");
  }

  return _pushScreens(state, screens);
}

// -----------------------------------------------------------------------------
//  Helpers
// -----------------------------------------------------------------------------
const errorsScreen = [
  "model_unavailable",
  "booking_time_invalid",
  "booking_time_invalid_multi",
];
function isErrorScreen(err) {
  return _includes(errorsScreen, err);
}
